import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MY_DATE_FORMATS } from './core/config';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { PermissionService } from './core/services/permission.service';
import { environment } from './environments/environment';
import { Apps } from './shared/enums/enum';
import { LayoutModule } from './shared/features/layout/layout.module';
import { UserService } from './shared/services/user.service';
import { ShippingCarriersModule } from './modules/shipping-carriers/shipping-carriers';

export function restoreSessionInitializer() {
  const userService = inject(UserService);
  try {
    return userService.restoreUserSession();
  } catch (error) {
    return Promise.resolve();
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    ShippingCarriersModule,
    HttpClientModule,
    MatMomentDateModule,
    MatDatepickerModule,
    MatInputModule,
    NgxPermissionsModule.forRoot(),
  ],
  providers: [
    provideAppInitializer(restoreSessionInitializer),
    provideAppInitializer(() => {
      const svc = inject(PermissionService);
      return svc.ensurePermissionsLoaded(Apps.IMS);
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: 'BASE_URL', useValue: environment.companyApiUrl },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
